import ReturnsRmaTableMobile from './ReturnsRmaTableMobile';
import { withI18n } from 'react-i18next';

export default withI18n()(ReturnsRmaTableMobile);
